/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class  QueryConfigurationModel {
        private logType: string = "QueryConfigurationModel";

        private systemLevel: Wars.Domain.Model.SystemLevel;
        public queries: Wars.Domain.Model.QueryConfiguration[] = [];
        public currentQuery:Wars.Domain.Model.QueryConfiguration;
        public dataSources: Wars.Domain.Model.DataSource[];
        public selectedDataSource: Wars.Domain.Model.DataSource;
        public newTag:string;
        public tags: string[];

        constructor(
            private queryConfigurationService: services.QueryConfigurationService,
            private systemLevelService: services.SystemLevelService,
            private treeService: services.TreeService,
            private tagService: services.TagService,
            private $q: angular.IQService,
            private processConfigurationId?: string)
        {
            var self = this;

            if(!processConfigurationId) {
                processConfigurationId = null;
            }

            if (processConfigurationId) {
                queryConfigurationService.getAllQueryConfigurations(processConfigurationId).then(r => {
                    self.queries = r;
                    if (!self.queries) {
                        self.queries = [];
                    }

                });
            } else {
                systemLevelService.getSystemLevelQueryConfigurations().then(
                (systemLevel) => {
                    self.systemLevel = systemLevel;
                    self.queries = systemLevel.myQueryConfigurations;
                });
            }

            queryConfigurationService.getDataSources(processConfigurationId).then(d => {
                self.dataSources = d;     
                if (processConfigurationId) {
                    queryConfigurationService.getDataSources().then(results => {
                        results.forEach(r => {
                            self.dataSources.push(r);
                        });
                    });
                }
            });

            tagService.getTagsLike(Wars.Domain.Model.Codes.Enums.TagType.Query)
                .then(result => {
                    self.tags = Enumerable.from(result).select(i => i.tagName).distinct().toArray();
                    services.WarsLogger.logDebug("Matching Tags", this.logType, self.tags);
                    if(self.tags.length === 0){
                        self.tags.push('test');
                    }
                });
        }

        public selectQuery(query:Wars.Domain.Model.QueryConfiguration){
            this.selectedDataSource = query.myDataOperation.myDataSource;
            this.currentQuery = query;
        }

        public addQuery() {
            var newQuery = this.queryConfigurationService.createNewQueryConfiguration();
            this.queries.push(newQuery);
            this.currentQuery = newQuery;
            this.currentQuery.processConfiguration_id = this.processConfigurationId;
            services.WarsLogger.logInfo("New Query Object", this.logType, this.currentQuery);
            //this.save();
        }

        public dataSourceChanged() {
            services.WarsLogger.logInfo("Data Source Selected", this.logType, this.selectedDataSource);
        }

        public getTreeItemName(treeItem: Wars.Domain.Model.TreeItem): string {
            if (!treeItem) return '';
            return this.treeService.getDisplayName(treeItem);
        }
        
        public onDropTreeItem($event, queryParameter: Wars.Domain.Model.OperationParameter) {
            var treeItem = this.treeService.createTreeItemFromItemDropped();

            queryParameter.treeItem = treeItem;
            queryParameter.treeItem_id = treeItem.id;
        }

        public save() {
            this.queryConfigurationService.saveAllChanges();
        }

        public addTag(tag) {
            var newTag = this.tagService.createTag();
            newTag.tagName = tag.text;
            newTag.tagType = Wars.Domain.Model.Codes.Enums.TagType.Query;
            newTag.condition_id = null;
            newTag.calculation_id = null;
            newTag.queryConfiguration_id = this.currentQuery.id;
            newTag.myQueryConfiguration= this.currentQuery;

            this.currentQuery.tags.push(newTag);
        }

        public removeTag(tag) {
            this.currentQuery.tags.forEach(t => {
                if (t.tagName === tag.text) {
                    t.entityAspect.setDeleted();
                }
            });
        }

        public searchTags(query: string) {
            var queryLength = query.length;
            var defrred = this.$q.defer();
            var returnTags = Enumerable.from(this.tags)
                .where(i => i.substring(0, queryLength) === query)
                .toArray();
            defrred.resolve(returnTags);
            return defrred.promise;
        }

        public operationChanged() {
            var self = this;

            this.currentQuery.parameters.forEach(p => {
                p.entityAspect.setDeleted();
            });

            this.currentQuery.myDataOperation.parameters.forEach(p => {
                var queryParameter = self.queryConfigurationService.createNewQueryParameter();
                queryParameter.name = p.name;
                this.currentQuery.parameters.push(queryParameter);
            });
        }
    }
}